module.exports = __webpack_public_path__ + "static/media/shekel-sign.dc4d8624.svg";